export const printLog = (...args) => {
  if (process.env.VUE_APP_LIFESYCLE_ENVIRONMENT_TYPE !== 'production' || process.env.NODE_ENV === 'development') {
    console.log(...args);
  }
};
